import { Component, OnInit } from '@angular/core';


import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';
@Component({
  selector: 'app-attorney-recording',
  templateUrl: './attorney-recording.component.html',
  styleUrls: ['./attorney-recording.component.css']
})
export class AttorneyRecordingComponent implements OnInit {
  visible=false;
  token:any;
  record:any;
  userWithToken:any;
  error:any;
  searchText:any;
  users:any;
  loggedUser:any;
  toggle=true;
  attorneyName="";
  attorneyAdress=""
  attorneyId="";
  constructor(private userData:UserDataService, private auth:AuthService, private route:Router ){}
   aslan=true;



    ngOnInit() {


     this.token=this.auth.token;
      this.loggedUser=this.auth.userMail;

     }





  findAttorney() {
    this.visible=!this.visible;
    this.userData.fetchAttorney(this.token).subscribe(
     (res: any) => {
      if (!res) {
        this.record="Vekil kaydı bulunamadı";
        alert("Vekil kaydı bulunamadı")
      } else {

   //   console.log(res);
      this.userWithToken=res;
      this.users = Object.keys(res).map((key) =>
      { return res[key] });

      this.users.key = Object.keys(res).map((key) =>
      { return (key) });

     console.log(this.users);
      this.record=""
    }},err=>this.error=(err.statusText)
  );
  }

  removeAttorney(i:number) {
    if(confirm(this.users[i][0].AttorneyName+" vekil kaydı silinecektir. Onaylıyor musunuz?")){
   // console.log(this.users[i][0]);
   /* this.userData.deletionRecords([this.loggedUser,Date.now()],"Başvuru Sahibi kaydı silindi",this.users[i][0]).subscribe();*/
   this.userData.deletionRecords([this.loggedUser,Date.now()],'Vekil kaydı silindi', `Silinen Vekil: ${this.users[i][0].AttorneyName} `).subscribe();
   // console.log(this.loggedUser);
    /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
    this.userData.removeAttorney(this.users.key[i]);
    this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
    this.route.navigate(['masterData']));
  alert('Vekil kaydı silindi')}
    //this.redirectTo('masterData');
  }




  redirectTo(uri:string){
    this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.route.navigate([uri]));
 }
  //this.redirectTo('masterData');
    submit() {
      var record=[];
      this.toggle=false;
      this.attorneyName=this.attorneyName?.toLowerCase()
      this.attorneyAdress=this.attorneyAdress?.toLowerCase()
      this.attorneyId=this.attorneyId?.toLowerCase()
      console.log(this.attorneyName,this.attorneyAdress,this.attorneyId)
        record.push({recordingUser:this.loggedUser, date:Date.now()});
            this.userData.addAttorney(
                            this.attorneyName,
                            this.attorneyAdress,
                            this.attorneyId,
                            record
                            ).
                            subscribe(arr=>{console.log(arr);
                            alert("Vekil kaydedildi")},
                            err=>{
                            this.error=err.statusText;
                            console.log(this.error)});
                            this.users=[];
                            this.record="Vekil Kaydedildi";
  }




}
